<header class="header">
    <img src="assets/twint_logo_q_pos_bg.png" />
    <button *ngIf="isUserLoggedIn" (click)="onLogout()">Logout</button>
</header>
